import { MessageDescriptor } from 'react-intl'

import * as bankTransferActionTypes from './actionTypes'
import { Bank } from './types'

export interface FetchBanksAction {
  type: typeof bankTransferActionTypes.FETCH_BANKS_TYPE
}
export interface SetFetchingBanksAction {
  payload: boolean
  type: typeof bankTransferActionTypes.SET_FETCHING_BANKS_TYPE
}
export interface SetFetchBanksErrorAction {
  payload: string
  type: typeof bankTransferActionTypes.SET_FETCH_BANKS_ERROR_TYPE
}
export interface SetBanksAction {
  payload: Bank[]
  type: typeof bankTransferActionTypes.SET_BANKS_TYPE
}
export interface FetchBankAction {
  payload: { id: string }
  type: typeof bankTransferActionTypes.FETCH_BANK_TYPE
}
export interface SetFetchingBankAction {
  payload: { fetching: boolean; id: string }
  type: typeof bankTransferActionTypes.SET_FETCHING_BANK_TYPE
}
export interface SetFetchBankErrorAction {
  payload: { error: string; id: string }
  type: typeof bankTransferActionTypes.SET_FETCH_BANK_ERROR_TYPE
}
export interface SetBankAction {
  payload: { bank: Bank; id: string }
  type: typeof bankTransferActionTypes.SET_BANK_TYPE
}

export interface SetBankSettlementAction {
  payload: {
    bank: Bank
    message: MessageDescriptor
    settlementResponse: any
  }
  type: typeof bankTransferActionTypes.SET_BANK_SETTLEMENT_TYPE
}
export interface CreateBankLinkAction {
  payload: { currency: string }
  type: typeof bankTransferActionTypes.CREATE_BANK_LINK
}
export interface CreateBankLinkSuccessAction {
  payload: { data: Bank }
  type: typeof bankTransferActionTypes.CREATE_BANK_LINK_SUCCES
}
export interface FetchBankLinkTokenForRefreshAction {
  payload: { bankId: string }
  type: typeof bankTransferActionTypes.FETCH_BANK_LINK_TOKEN_FOR_REFRESH
}

export interface UpdateBankLinkAction {
  payload: { attributes: object; bankId: string }
  type: typeof bankTransferActionTypes.UPDATE_BANK_LINK
}

export interface FetchBankSettlementAction {
  payload: { attributes: object; bank: Bank }
  type: typeof bankTransferActionTypes.FETCH_BANK_SETTLEMENT
}

export interface ClearBankSettlementAction {
  type: typeof bankTransferActionTypes.CLEAR_BANK_SETTLEMENT
}
export interface UpdateBankLinkSuccessAction {
  payload: { data: Bank }
  type: typeof bankTransferActionTypes.UPDATE_BANK_LINK_SUCCES
}
export interface BlockBankAction {
  payload: { id: string }
  type: typeof bankTransferActionTypes.BLOCK_BANK
}
export interface BlockBankSuccessAction {
  payload: { id: string }
  type: typeof bankTransferActionTypes.BLOCK_BANK_SUCCESS
}
export type PaymentBanksActionType =
  | FetchBanksAction
  | SetFetchingBanksAction
  | SetFetchBanksErrorAction
  | SetBanksAction
  | CreateBankLinkAction
  | CreateBankLinkSuccessAction
  | UpdateBankLinkAction
  | UpdateBankLinkSuccessAction
  | FetchBankAction
  | SetFetchingBankAction
  | SetFetchBankErrorAction
  | SetBankAction
  | BlockBankAction
  | BlockBankSuccessAction
  | FetchBankLinkTokenForRefreshAction
  | SetBankSettlementAction
  | FetchBankSettlementAction
  | ClearBankSettlementAction

export const fetchBanks = (): PaymentBanksActionType => ({
  type: bankTransferActionTypes.FETCH_BANKS_TYPE
})
export const setFetchingBanks = (fetching: boolean): PaymentBanksActionType => ({
  payload: fetching,
  type: bankTransferActionTypes.SET_FETCHING_BANKS_TYPE
})
export const setFetchBanksError = (error: string): PaymentBanksActionType => ({
  payload: error,
  type: bankTransferActionTypes.SET_FETCH_BANKS_ERROR_TYPE
})
export const setBanks = (banks: Bank[]): PaymentBanksActionType => ({
  payload: banks,
  type: bankTransferActionTypes.SET_BANKS_TYPE
})

export const setBankSettlement = (
  settlementResponse: any,
  message: MessageDescriptor,
  bank: Bank
): PaymentBanksActionType => {
  return {
    payload: { bank, message, settlementResponse },
    type: bankTransferActionTypes.SET_BANK_SETTLEMENT_TYPE
  }
}

export const fetchBank = (id: string): PaymentBanksActionType => ({
  payload: { id },
  type: bankTransferActionTypes.FETCH_BANK_TYPE
})
export const setFetchingBank = (id: string, fetching: boolean): PaymentBanksActionType => ({
  payload: { fetching, id },
  type: bankTransferActionTypes.SET_FETCHING_BANK_TYPE
})
export const setFetchBankError = (id: string, error: string): PaymentBanksActionType => ({
  payload: { error, id },
  type: bankTransferActionTypes.SET_FETCH_BANK_ERROR_TYPE
})

export const fetchBankSettlement = (attributes: object, bank: Bank): PaymentBanksActionType => ({
  payload: { attributes, bank },
  type: bankTransferActionTypes.FETCH_BANK_SETTLEMENT
})

export const clearBankSettlement = (): PaymentBanksActionType => ({
  type: bankTransferActionTypes.CLEAR_BANK_SETTLEMENT
})

export const setBank = (id: string, bank: Bank): PaymentBanksActionType => ({
  payload: { bank, id },
  type: bankTransferActionTypes.SET_BANK_TYPE
})

export const createBankLink = (currency: string): PaymentBanksActionType => ({
  payload: { currency },
  type: bankTransferActionTypes.CREATE_BANK_LINK
})
export const createBankLinkSuccess = (data: Bank): PaymentBanksActionType => ({
  payload: { data },
  type: bankTransferActionTypes.CREATE_BANK_LINK_SUCCES
})

export const updateBankLink = (bankId: string, attributes: object): PaymentBanksActionType => ({
  payload: { attributes, bankId },
  type: bankTransferActionTypes.UPDATE_BANK_LINK
})

export const fetchBankLinkTokenForRefresh = (bankId: string): PaymentBanksActionType => ({
  payload: { bankId },
  type: bankTransferActionTypes.FETCH_BANK_LINK_TOKEN_FOR_REFRESH
})

export const updateBankLinkSuccess = (bank: Bank): PaymentBanksActionType => ({
  payload: { data: bank },
  type: bankTransferActionTypes.UPDATE_BANK_LINK_SUCCES
})
export const blockBank = (id: string): PaymentBanksActionType => ({
  payload: { id },
  type: bankTransferActionTypes.BLOCK_BANK
})
export const blockBankSuccess = (id: string): PaymentBanksActionType => ({
  payload: { id },
  type: bankTransferActionTypes.BLOCK_BANK_SUCCESS
})
